import { Injectable } from '@angular/core';

import { type HknIdentifier } from '@clean-code/models';
import { FormBaseService } from '@clean-code/shared/util/util-component-services';
import { HknIdentifierService } from '../services/hkn-identifier.service';

@Injectable({ providedIn: 'root' })
export class HknIdentifierFormFacade extends FormBaseService<HknIdentifier> {
  constructor(service: HknIdentifierService) {
    super(service);
  }
}
